// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","365":"cb355538","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"8ed318d8d4cf32931fb9","365":"b88f216a414ce8728fbd","691":"b780608d8e2bd91e1a7b"}[chunkId] + ".js";
};